/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import {
    SET_DATE_FILTER,
    SET_FILTERED_TOUR_LIST,
    SET_IS_FILTER_MODAL_OPEN,
    CLEAR_FILTERS,
    SET_GUEST_COUNT,
    SET_TOUR_TIME_FILTER,
} from '../actions/filtersActions';

export const initialState = {
    date: null,
    guestCount: null,
    filteredTourIds: null,
    isFilterModalOpen: false,
    tourTimeFilter: {
        earlyMorning: false,
        morning: false,
        earlyAfternoon: false,
        afternoon: false,
        evening: false,
        lateNight: false,
    },
    hasTourTimeFilter: false,
};

export const filters = (state = initialState, action) => {
    switch (action.type) {
        case SET_IS_FILTER_MODAL_OPEN:
            return {
                ...state,
                isFilterModalOpen: action.payload,
            };
        case CLEAR_FILTERS:
            return {
                ...state,
                date: null,
                guestCount: null,
                filteredTourIds: null,
            };
        case SET_DATE_FILTER:
            return {
                ...state,
                date: action.payload,
            };
        case SET_FILTERED_TOUR_LIST:
            return {
                ...state,
                filteredTourIds: action.payload,
            };
        case SET_GUEST_COUNT:
            return {
                ...state,
                guestCount: action.payload,
            };
        case SET_TOUR_TIME_FILTER:
            return {
                ...state,
                tourTimeFilter: action.payload,
                hasTourTimeFilter:
                    action.payload.earlyMorning ||
                    action.payload.morning ||
                    action.payload.earlyAfternoon ||
                    action.payload.afternoon ||
                    action.payload.evening ||
                    action.payload.lateNight,
            };
        default:
            return state;
    }
};
